module.exports = new __parcel__URL__("closed-hihat_5.84f49b25.mp3").toString();